import React from "react";

import {
	About,
	ContactUsLink,
	ContactUsModal,
	CurrentUserAvatar,
	GuideButton,
	GuideBotButton,
	WebSocketProvider,
	HomeLink,
	LogOut,
	OtherResources,
} from "@digatex/digatex-ui-lib";
import {Layout, Space, Typography} from "antd";

import api from "../../api";
import {properties} from "../../properties";

import "../helpers.css";
import "../../Dashboard.css";

function sendEmail(formData) {
	return api.post(`/email/contact`, formData);
}

class DHeader extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showContactForm: false,
			triedToSubmit: false,
			submitInProgress: false,
			project: {},
		};

		this.formRef = React.createRef();
	}

	componentDidMount() {
		const projectId = document.location.pathname.split("/")[2];
		if (projectId) {
			api.get(`/projects/${projectId}/info`).then(json => this.setState({project: json.data}));
		}
	}

	render() {
		return (
			<div>
				<Layout.Header
					style={{padding: 10, display: "flex", justifyContent: "space-between", alignItems: "center"}}>
					{!this.props.isLanding ? <HomeLink /> : <HomeLink title={<div style={{width: 50}}></div>} />}
					{this.props.isLanding && (
						<Typography.Title
							level={3}
							style={{color: "white", paddingLeft: 32, paddingTop: 7.25, marginLeft: "auto"}}>
							{properties.landingHeaderName}
						</Typography.Title>
					)}
					{this.state.project.project_name && (
						<Typography.Title
							level={3}
							style={{color: "white", paddingLeft: 32, paddingTop: 7.25, marginLeft: "auto"}}>
							Project: {this.state.project.project_name}
						</Typography.Title>
					)}

					<div style={{marginLeft: "auto"}}>
						<Space size={"middle"}>
							<About />
							<OtherResources />
							{properties.guideBotApiLink && properties.guideBotWSLink ? (
								<div style={{paddingTop: 12}}>
									<WebSocketProvider moduleName="workbench">
										<GuideBotButton />
									</WebSocketProvider>
								</div>
							) : (
								<GuideButton module="workbench" />
							)}
                            <ContactUsLink show={() => this.setState({showContactForm: true})} />
							<LogOut />
							<CurrentUserAvatar />
						</Space>
					</div>
				</Layout.Header>
				<ContactUsModal
					show={this.state.showContactForm}
					sendEmail={sendEmail}
					close={() => this.setState({showContactForm: false})}
				/>
			</div>
		);
	}
}

export const DashboardHeader = DHeader;
